import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk to fetch dashboard metrics
export const fetchDashboardMetrics = createAsyncThunk(
  "dashboard/fetchMetrics",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch("/api/v1/admin/dashboard/metrics");
      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.error || "Failed to fetch metrics");
      }
      const data = await res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    metrics: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearMetrics(state) {
      state.metrics = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardMetrics.fulfilled, (state, action) => {
        state.metrics = action.payload;
        state.loading = false;
      })
      .addCase(fetchDashboardMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMetrics } = dashboardSlice.actions;

export const selectDashboardMetrics = (state) => state.dashboard.metrics;
export const selectDashboardLoading = (state) => state.dashboard.loading;
export const selectDashboardError = (state) => state.dashboard.error;

export default dashboardSlice.reducer;
